module.exports = __webpack_public_path__ + "img/Image 2.d5a2703e.png";